import React from 'react'
import { useSurveyStore } from '../../surveyutilities/surveyStore'
import TextBlock from '../blocks/TextBlock';
import TextAreaBlock from '../blocks/TextAreaBlock';
import SingleChoiceBlock from '../blocks/SingleChoiceBlock';
import MultipleChoiceBlock from '../blocks/MultipleChoiceBlock';
import DropdownBlock from '../blocks/DropdownBlock';
import RatingBlock from '../blocks/RatingBlock';
import FileUploadBlock from '../blocks/FileUploadBlock';
import BlockControls from './BlockControls';
import { Box, Paper, Chip, Typography } from '@mui/material';
import BlockSettingsControl from './BlockSettingsControl';
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  Delete,
  Add,
  Remove,
  DragIndicator,
  Upload
} from '@mui/icons-material';

// Import QUESTION_TYPES from your store instead of trying to get it from useSurveyStore
import { QUESTION_TYPES } from '../../surveyutilities/surveyStore';

const MainBlock = React.memo(({ block, index, totalBlocks }) => {
    console.log('MainBlock rendering:', block.id, block.type)
    
    // Correctly access the store values - use separate selectors
    const selectedQuestionId = useSurveyStore(state => state.selectedQuestionId)
    const selectQuestion = useSurveyStore(state => state.selectQuestion)

    
    const isSelected = selectedQuestionId === block.internalId;
    const isFirst = index === 0;
    const isLast = index === totalBlocks - 1;

    const handleBlockClick = () => {
        selectQuestion(block.internalId);
    };

    const renderBlockContent = () => {
        switch (block.type) {
            case QUESTION_TYPES.TEXT:
                return <TextBlock block={block} position = {index}/>;
            case QUESTION_TYPES.TEXTAREA:
                return <TextAreaBlock block={block} position = {index} />;
              case QUESTION_TYPES.SINGLE_CHOICE:
                    return <SingleChoiceBlock block={block} position = {index} />;
                case QUESTION_TYPES.MULTIPLE_CHOICE:
                    return <MultipleChoiceBlock block={block} position = {index} />;
                case QUESTION_TYPES.DROPDOWN:
                    return <DropdownBlock block={block}  position = {index}/>;
                case QUESTION_TYPES.RATING:
                    return <RatingBlock block={block} position = {index} />;
              case QUESTION_TYPES.FILE_UPLOAD:
                    return <FileUploadBlock block={block} position = {index} />;
            default:
                return <Typography>Unknown block type: {block.type}</Typography>;
        }
    }

    return (
        <Box
            sx={{
                position: 'relative',
                mb: 2,
                '&:hover .block-controls': {
                    opacity: 1
                }
            }}
        >
            <Paper
                elevation={isSelected ? 3 : 0}
                sx={{
                    p: 3,
                    cursor: 'pointer',
                    border: isSelected ? '2px solid #1976d2' : '2px solid transparent',
                    borderRadius: 2,
                    transition: 'all 0.2s ease-in-out',
                    bgcolor: isSelected ? 'rgba(25, 118, 210, 0.04)' : 'white',
                    '&:hover': {
                        boxShadow: 2,
                        bgcolor: isSelected ? 'rgba(25, 118, 210, 0.04)' : 'grey.50'
                    }
                }}
                onClick={handleBlockClick}
            >
                {/* Block Header
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <DragIndicator sx={{ color: 'grey.400', mr: 1 }} />
                    <Chip
                        label={block.type}
                        size="small"
                        color={isSelected ? 'primary' : 'default'}
                        variant={isSelected ? 'filled' : 'outlined'}
                    />
                </Box>
                */}
                {/* Block Content */}
                {renderBlockContent()}

                {/* Block Movement Controls */}
                {isSelected && (
                    <>
                    <BlockControls 
                        block={block} 
                        isFirst={isFirst} 
                        isLast={isLast}
                        className="block-controls"
                    />
                    <BlockSettingsControl
                        block={block}
                    />
                    </>
                )}
            </Paper>
        </Box>
    )
})

// Add display name for better debugging
MainBlock.displayName = 'MainBlock';

export default MainBlock;